import { Auth } from 'aws-amplify';

const USER_POOLS_PROVIDER_NAME =
  process.env.REACT_APP_AWS_USER_POOLS_PROVIDER_NAME;

export const ERROR_INVALID_REFRESH_TOKEN_CODE = 'NotAuthorizedException';

/**
 * Get user information
 * Return false if there is no user data
 * @returns {Boolean | Object}
 */
export const getUserInfo = async () => {
  try {
    const userInfo = await Auth.currentSession();

    return userInfo;
  } catch (error) {
    return false;
  }
};

/**
 * Sign in
 */
export const signIn = () => {
  Auth.federatedSignIn({ provider: USER_POOLS_PROVIDER_NAME });
};

/**
 * Sign out
 */
export const signOut = async () => {
  await Auth.signOut();
};

/**
 * Get JWT token
 * @returns {Promise<String>}
 */
export const getJwtToken = async () => {
  let jwtToken;
  try {
    jwtToken = (await Auth.currentSession()).getAccessToken().getJwtToken();
  } catch (error) {
    // If the refresh token is invalid -> Amplify clears authorization data in localStorage
    // So we just redirect to landing page
    if (error.code === ERROR_INVALID_REFRESH_TOKEN_CODE) {
      window.location.href = '/';
    }

    throw error;
  }

  return jwtToken;
};

/**
 * Get user id
 * @returns {Promise<String>}
 */
export const getUserId = async () => {
  const userId = (await Auth.currentSession()).getIdToken()?.payload?.sub;

  return userId;
};

export const getAppSyncAuthorizationInfo = (host) => async () => {
  const jwtToken = await getJwtToken();

  return {
    Authorization: jwtToken,
    host
  };
};

export const getUserName = (userName, profileName) => {
  // professional username is always "-" so patch it by PUDS api(profile info)
  return !userName || userName === '-' ? profileName : userName;
};

export const setUserPolicyAgreement = async () => {
  const user = await Auth.currentAuthenticatedUser();
  return Auth.updateUserAttributes(user, {
    'custom:policyAgreementAt': new Date().toISOString(),
    'custom:policyAgreementVer': process.env.REACT_APP_PP_AGREEMENT_VERSION
  });
};
